// extracted by mini-css-extract-plugin
module.exports = {"summary":"OverviewFiltersSummary_summary__3kx_z","chips":"OverviewFiltersSummary_chips__LunNN","nohits":"OverviewFiltersSummary_nohits__78jk7"};